module.exports = __webpack_public_path__ + "static/media/PingFangHK Light-01.dab44ca3.svg";